/** @format */

import React from 'react'

import { Form, Input } from 'antd'

import './style.css'
import { rulesValidation } from './rules'

export default function InputField(props) {
	return (
		<>
			<h3 className='ph-login-main-form-label'>{props.inputNameLabel}</h3>
			<Form.Item name={props.inputName} rules={rulesValidation[props.inputNameRules]}>
				<Input
					className='ph-login-main-form-field'
					size='large'
					prefix={props.inputNameIcon}
					type={props.inputNameType}
					placeholder={props.inputNameLabel}
					bordered={props.bordered}
				/>
			</Form.Item>
		</>
	)
}
